import { Dialog } from '@bsf/force-ui';
import RenderContent from './render-content';
import useStore, { actionTypes } from '@/store';

const LearnMoreDialog = () => {
	const {
		dispatch,
		learnMoreDialogOpen: open,
		currentLearnMoreDialogItem: item,
	} = useStore();

	const handleLearnMoreDialogOpen = () => {
		dispatch( {
			type: actionTypes.SET_LEARN_MORE_DIALOG_OPEN,
			payload: false,
		} );
	};

	return (
		<Dialog
			design="simple"
			exitOnEsc
			scrollLock
			exitOnClickOutside
			open={ open }
			setOpen={ ( value ) => handleLearnMoreDialogOpen( value ) }
		>
			<Dialog.Backdrop />
			<Dialog.Panel className="w-[90vw] max-w-[672px] gap-2 max-h-[85vh] sm:max-h-[80vh] mx-auto">
				<Dialog.Header className="px-4 sm:px-5 pb-0">
					<div className="flex items-center justify-between">
						<Dialog.Title className="text-base">
							{ item?.title }
						</Dialog.Title>
						<Dialog.CloseButton />
					</div>
				</Dialog.Header>

				<Dialog.Body className="px-4 sm:px-5 pb-4 sm:pb-5 flex flex-col gap-2 sm:gap-2.5 overflow-auto">
					<RenderContent items={ item?.content } />
				</Dialog.Body>
			</Dialog.Panel>
		</Dialog>
	);
};

export default LearnMoreDialog;
